import { IconTheme } from '@/components/atoms/IconTheme/IconTheme'
import { Card } from '@/features/Cards/cards.types'
import { CardIcon } from '@/features/Cards/ui/CardIcon/CardIcon'
import { CardIconMore } from '@/features/Cards/ui/CardIconMore/CardIconMore'
import { Button } from 'antd'
import React from 'react'
import styles from './CardsPreview.module.scss'

type Props = {
  cards: Card[];
  addAction?: () => void;
  linkAction?: () => void;
  extended?: boolean;
  withAdd?: boolean;
  withLink?: boolean;
}

export function CardsPreview({ cards, withAdd = false, addAction, extended, withLink, linkAction }: Props) {
  if (!cards) return null

  return (
    <>
      {extended && (
        <>
          {cards.map((cardInner) => <CardIcon key={cardInner.id} pan={cardInner.panMasked.slice(-4)} />)}
        </>
      )}
      {!extended && (
        <>
          {cards.length <= 2 && cards.map((cardInner) => <CardIcon key={cardInner.id} pan={cardInner.panMasked.slice(-4)} />)}
          {cards.length > 2 && (
            <>
              <CardIcon pan={cards[0].panMasked.slice(-4)} />
              <CardIconMore size={cards.length - 1} />
            </>
          )}
        </>
      )}
      {withAdd && (
        <Button onClick={addAction} className={styles.addButton}>
          <IconTheme icon={(
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.869629 6.71191C0.869629 6.4873 0.950195 6.29443 1.11133 6.1333C1.27246 5.96729 1.46533 5.88428 1.68994 5.88428H6.17969V1.40186C6.17969 1.17725 6.26025 0.984375 6.42139 0.823242C6.58252 0.662109 6.77539 0.581543 7 0.581543C7.22949 0.581543 7.4248 0.662109 7.58594 0.823242C7.74707 0.984375 7.82764 1.17725 7.82764 1.40186V5.88428H12.3101C12.5347 5.88428 12.7275 5.96729 12.8887 6.1333C13.0498 6.29443 13.1304 6.4873 13.1304 6.71191C13.1304 6.94141 13.0498 7.13672 12.8887 7.29785C12.7275 7.4541 12.5347 7.53223 12.3101 7.53223H7.82764V12.0293C7.82764 12.249 7.74707 12.4395 7.58594 12.6006C7.4248 12.7617 7.22949 12.8423 7 12.8423C6.77539 12.8423 6.58252 12.7617 6.42139 12.6006C6.26025 12.4395 6.17969 12.249 6.17969 12.0293V7.53223H1.68994C1.46533 7.53223 1.27246 7.4541 1.11133 7.29785C0.950195 7.13672 0.869629 6.94141 0.869629 6.71191Z"
                fill="#050510"
                fillOpacity="0.52"
              />
            </svg>
          )}
          />
        </Button>
      )}
      {withLink && (
        <Button onClick={linkAction} className={styles.addButton}>
          <IconTheme icon={(
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.00537 4.91455C8.47412 4.99756 8.86475 5.11963 9.17725 5.28076C9.48975 5.43701 9.76074 5.63232 9.99023 5.8667C10.5859 6.45752 10.9814 7.10938 11.1768 7.82227C11.3721 8.53027 11.3696 9.23828 11.1694 9.94629C10.9741 10.6543 10.5835 11.3013 9.99756 11.8872L7.49268 14.3994C6.91162 14.9805 6.26709 15.3687 5.55908 15.564C4.85107 15.7642 4.14062 15.7666 3.42773 15.5713C2.71973 15.376 2.06787 14.9805 1.47217 14.3848C0.881348 13.7939 0.488281 13.1445 0.292969 12.4365C0.0976562 11.7236 0.0976562 11.0132 0.292969 10.3052C0.493164 9.59717 0.883789 8.9502 1.46484 8.36426L3.61816 6.21826C3.5791 6.45752 3.57178 6.70898 3.59619 6.97266C3.62549 7.23145 3.69141 7.47559 3.79395 7.70508L2.3584 9.14062C1.93359 9.56543 1.65039 10.0342 1.50879 10.5469C1.36719 11.0596 1.36719 11.5747 1.50879 12.0923C1.65039 12.605 1.93359 13.0762 2.3584 13.5059C2.7832 13.9307 3.25195 14.2114 3.76465 14.3481C4.28223 14.4897 4.79736 14.4897 5.31006 14.3481C5.82275 14.2065 6.2915 13.9233 6.71631 13.4985L9.11133 11.1108C9.53613 10.686 9.81689 10.2173 9.95361 9.70459C10.0952 9.19189 10.0952 8.6792 9.95361 8.1665C9.81201 7.64893 9.52881 7.17529 9.104 6.74561C8.86475 6.50635 8.5791 6.31592 8.24707 6.17432C7.91992 6.03271 7.51465 5.94238 7.03125 5.90332L8.00537 4.91455ZM7.82227 10.9497C7.35352 10.8667 6.96289 10.7471 6.65039 10.5908C6.33789 10.4297 6.06689 10.2319 5.8374 9.99756C5.2417 9.40674 4.84619 8.75732 4.65088 8.04932C4.45557 7.33643 4.45557 6.62598 4.65088 5.91797C4.85107 5.20996 5.24414 4.56299 5.83008 3.97705L8.32764 1.47217C8.91357 0.88623 9.56055 0.495605 10.2686 0.300293C10.9766 0.100098 11.6846 0.0976562 12.3926 0.292969C13.1055 0.488281 13.7598 0.883789 14.3555 1.47949C14.9463 2.07031 15.3394 2.72217 15.5347 3.43506C15.73 4.14307 15.7275 4.85107 15.5273 5.55908C15.332 6.26709 14.9438 6.91406 14.3628 7.5L12.2095 9.646C12.2485 9.40674 12.2534 9.15771 12.2241 8.89893C12.1997 8.64014 12.1362 8.39355 12.0337 8.15918L13.4692 6.72363C13.894 6.29883 14.1772 5.83008 14.3188 5.31738C14.4604 4.80469 14.4604 4.29199 14.3188 3.7793C14.1772 3.26172 13.894 2.79053 13.4692 2.36572C13.0396 1.93604 12.5684 1.65283 12.0557 1.51611C11.543 1.37451 11.0303 1.37451 10.5176 1.51611C10.0049 1.65771 9.53369 1.94092 9.104 2.36572L6.71631 4.75342C6.2915 5.17822 6.0083 5.64697 5.8667 6.15967C5.7251 6.67236 5.7251 7.1875 5.8667 7.70508C6.0083 8.21777 6.29395 8.68896 6.72363 9.11865C6.96289 9.35791 7.24609 9.54834 7.57324 9.68994C7.90527 9.83154 8.31299 9.92188 8.79639 9.96094L7.82227 10.9497Z" fill="#050510" fillOpacity="0.52"/>
            </svg>
          )}
          />
        </Button>
      )}
    </>
  )
}
